import { api } from "./axios";

export async function getContents() {
    let res = await api.get("contents");
    if (res) return res.data.data;
    else return false;
}
export async function updateContent(data) {
    let res = await api.post("contents/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateNewContent(data) {
    let res = await api.post("contents/update");
    if (res) return res.data.data;
    else return false;
}


export async function getContentSocials() {
    let res = await api.get("website/content/socials");
    if (res) return res.data.data;
    else return false;
}

export async function createContentSocials(data) {
    let res = await api.post("contents/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateContentSocials(id, data) {
    let res = await api.post("contents/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}
export async function deleteContentSocials(id) {
    let res = await api.get("contents/destroy/" + id);
    if (res) return res.data.data;
    else return false;
}

export async function getContentTerms() {
    let res = await api.get("website/content/terms");
    if (res) return res.data.data;
    else return false;
}

export async function getContentAboutUs() {
    let res = await api.get("website/content/about_us");
    if (res) return res.data.data;
    else return false;
}

export async function getAllImagesSectionOne() {
    let res = await api.get("section/images/getAll");
    if (res) return res.data.data;
    else return false;
}
export async function createImagesSectionOne(data) {
    let res = await api.post("section/images/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function deleteImagesSectionOne(id) {
    let res = await api.get("section/images/remove/" + id);
    if (res) return res.data.data;
    else return false;
}
